// extracted by mini-css-extract-plugin
export var clauseRow = "_fa-6";
export var emptyState = "_fa-d";
export var filterContent = "_fa-a";
export var filterGroup = "_fa-1";
export var filterGroupContainer = "_fa-0";
export var nestedGroup = "_fa-2";
export var nestedGroupContent = "_fa-b";
export var nestedGroupDepth1 = "_fa-3";
export var nestedGroupDepth2 = "_fa-4";
export var nestedGroupDepth3 = "_fa-5";
export var nestedGroupEmpty = "_fa-c";
export var operatorAnd = "_fa-8";
export var operatorOr = "_fa-9";
export var operatorToggle = "_fa-7";
export var removeGroupButton = "_fa-e";